import { PATIENT_STATUS } from '@constants/PatientManagement/status'
import { IContact } from '@dataTypes/contact.type'
import { ICampaignMessage } from '@dataTypes/marketing.type'

export const getContactStatusList = (
  contacts?: IContact[] | null,
): string[] => {
  if (contacts) {
    const statusList = Array.from(
      new Set(
        contacts
          .map((p) =>
            p.patient?.patient_status !== undefined
              ? PATIENT_STATUS[p.patient?.patient_status]
              : (p.provider?.work_status ?? 'N/A'),
          )
          .filter((status): status is string => status !== undefined),
      ),
    )

    return statusList
  } else return []
}

export const getErrorTypeList = (messages: ICampaignMessage[]): string[] => {
  return Array.from(
    new Set(
      messages
        .map((m) => m.error_reason)
        .filter((reason): reason is string => typeof reason === 'string'),
    ),
  )
}

export const getCampaignNameList = (messages: ICampaignMessage[]): string[] => {
  return Array.from(
    new Set(
      messages
        .map((m) => m.campaign_name)
        .filter((name): name is string => typeof name === 'string'),
    ),
  )
}

export const getLocationList = (contacts?: IContact[] | null): string[] => {
  if (contacts) {
    return Array.from(new Set(contacts.map((c) => c.city)))
  } else return []
}
